import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/m/')({
	loader: () => redirect({ to: '/m/locations', search: true }),
})
